import React, { useRef, useState } from 'react'
import InnerCell from './InnerCell'
import styles from './styles'
import { colors } from '../defaultSettings'
import { DragTableContext } from '../Utils/DragTableContext'
import DropdownContainer from './DropdownContainer'
import SettingsIcon from './SettingsIcon'
import { trackError } from '../../../utils/activityTracker'

const Cell = props => {
  // get distance of drag event
  const { dragging, dragDistance } = React.useContext(DragTableContext)
  const [hover, setHover] = React.useState(false)

  // row state
  const [dropdown, setDropdown] = useState(false)
  // const [cellHeight, setCellHeight] = useState(props.heights[props.index]);
  // const dataKeys = Object.keys(props.data);
  const cellCount = props.headers.length
  // id for event handling
  const cellID = props.id + '-dt_cell'
  let eventIDs = useRef([cellID])

  const style = {
    ...styles.cellContainer,
    background: dragging ? props.background : dropdown ? colors.bg.title : null,
    cursor: (props.dropdown || props.route || props.modal) ? 'pointer' : null,
    borderColor: dropdown ? colors.title : colors.innerBorder,
    color: dropdown ? colors.highlightText : colors.text,
    height: props.heights[props.index] ? props.heights[props.index].height + 'px' : null,
    minHeight: props.heights[props.index] ? props.heights[props.index].height + 'px' : null
  }

  // handle dropdown if needed
  const toggleDropdown = (e) => {
    if (!dragging && eventIDs.current.includes(e.target.id)) {
      setDropdown(!dropdown)
      props.updateHeights(props.tableIndex, props.heights[props.tableIndex].height || 42, 0)
    }
  }
  const toggleModal = e => {
    if (!dragging && eventIDs.current.includes(e.target.id))
      !props.showModal ? props.setModal(props.data) : props.setModal(null)
  }

  // handle route manipulation
  const routeHandler = (e) => {
    if (!dragging && e.target.id) {
    // generate route useing endpoint settings
    // get key for the data value that controls endpoint location
      const routeKey = props.route.split('dtdata:').reverse()[0];
      // make sure the data is present to create route
      const isNotValidRoute = typeof props.data[routeKey] === 'undefined' || !props.data[routeKey];
      // replace route setting string with value from data using route key
      const route = props.route.replace(`dtdata:${routeKey}`, props.data[routeKey]);
      // set the new path
      let historyUpdate = { pathname: route }

      // new object to hold route state from settings
      let routeState = {}
      if (props.cellRouteSettings) {
      // loop through the route settings keys and add state based on format
        Object.keys(props.cellRouteSettings).forEach(key => {
          const val = props.cellRouteSettings[key]
          // split the value - 0 should tell the handler where to get the data
          // - 1 should tell the handler what key to use on the specified dataset
          if (typeof val === 'string' && val.includes(':')) {
            const stateSetting = val.split(':')
            if (stateSetting[0] === 'props') {
              routeState[key] = props[stateSetting[1]]
            } else if (stateSetting[0] === 'routeSettings') {
              routeState[key] = props.routeSettings[stateSetting[1]]
            }
          } else routeState[key] = val
        })
        routeState.activeFetchParam = props.activeFetchParam

        // add state object to route update
        if (routeState !== {}) historyUpdate.state = routeState
      }
      if (isNotValidRoute) {
        console.error('Not a valid route on cell. Check that the key passed behind "dtdata:" in the route, is in the data call. -- Cell->routeHandler')
        trackError({ error: 'Not a valid route on cell. Check that the key passed behind "dtdata:" in the route, is in the data call. -- Cell->routeHandler', history: props.history })
      }
      // push the update
      if (!isNotValidRoute) props.history.push(historyUpdate)
    }
  }

  // calc settings button right value
  const settingsBtnRightValue = props.controller.tableWidth < props.controller.headersTotalWidth
    ? props.controller.headersTotalWidth - props.controller.tableWidth // overflow amount
      + 40 + props.controller.headers.length - 3 // btn width and borders
      + dragDistance + 'px' // account for drag
    : 0

  const memoizedInnerCells = React.useMemo(() => props.headers
    ? props.headers.map((headerObj, i) => {
      const headerDataKey = props.headerSettings[headerObj.id]
        ? props.headerSettings[headerObj.id].key
        : headerObj.id
      const innerID = cellID + '-' + headerDataKey
      if (!eventIDs.current.includes(innerID)) eventIDs.current.push(innerID)
      let value = null
      if (headerDataKey && headerDataKey.includes('->')) {
        let dataStore = { ...props.data }
        headerDataKey.split('->').forEach(property => dataStore = dataStore[property])
        value = dataStore
      }

      return (
        <InnerCell
          value={value || props.data ? props.data[headerDataKey] : null}
          key={headerDataKey + i + headerObj.maxStringLength}
          id={innerID}
          dataID={props.id}
          activeFetchParam={props.activeFetchParam}
          first={i === 0}
          last={i === cellCount - 1}
          width={i === 0 ? parseInt(headerObj.widthValue) + 'px' : headerObj.widthValue}
          charCount={headerObj.maxStringLength}
          dropdown={dropdown}
          settings={props.headerSettings[headerObj.id]}
          data={props.data}
          actions={props.actions}
          setHeight={props.updateHeights}
          height={props.heights[props.tableIndex].height}
          index={props.index}
          groupCell={headerObj.id === 'dt_group_checkbox'}
          controller={props.controller}
        />
      )
    })
    : null, [props.headers, props.heights, props.width])

  return (
    <div
      style={{ transition: 'height .28s', height: props.wrapHeight }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div style={style}
        id={cellID}
        className={'xd_dt_cell' + (!props.even ? ' odd' : '')}
        onMouseUp={props.dropdown
          ? toggleDropdown
          : props.modal
            ? toggleModal
            : props.route
              ? routeHandler
              : null
        }>
        {memoizedInnerCells}
      </div>
      {props.dropdown && dropdown &&
        <DropdownContainer
          height={props.heights[props.tableIndex].customHeight}
          updateHeights={props.updateHeights}
          index={props.tableIndex}
          origHeight={props.heights[props.tableIndex] ? props.heights[props.tableIndex].height + 'px' : 42}
        >
          <props.dropdown
            data={props.data}
            location={props.location}
            dataRefresh={props.dataRefresh}
            memo={props.memo}
            userDetails={props.userDetails}
          />
        </DropdownContainer>
      }
    </div>
  )
}

export default Cell
